var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconOnlineLearningStudent4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.25 3.737a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.75 23.237h-7.5l.75-4.5h6l.75 4.5zm-9.75 0h12M8.947 7.978v.679a3.394 3.394 0 0 0 6.788 0v-.735m3.116-4.402L12.25.763 5.649 3.52l6.601 2.756 6.601-2.756zm-13.202 0v3.675m10.68 8.254a4.972 4.972 0 0 0-7.976 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconOnlineLearningStudent4);
export default __webpack_public_path__ + "static/media/streamline-icon-online-learning-student-4.41ede1ae.svg";
export { ForwardRef as ReactComponent };